<div class="uploadFile relative !pt-12">
  <input
  name="file"
  parentForm="fileForm"
  id="documentId"
  controlName="file"
  #documentId type="file"
  (change)="selectFile($event)"
  style="display: block" />
  <div *ngIf="!this.fileId && !isUploadingFile && version === 'card'" class="icon_image flex flex-col items-center" (click)="documentId.click()" style="cursor: pointer">
      <div class="px-[18px] py-[10px]">
        <fun-icon *ngIf="fileType === 'identityDocumentBack'" [name]="'id-card-back'" [style]="'w-48 h-48 stroke-[2px] stroke-pink-120'"></fun-icon>
        <fun-icon *ngIf="fileType !== 'identityDocumentBack'" [name]="'id-card'" [style]="'w-48 h-48 stroke-[2px] stroke-pink-120'"></fun-icon>
      </div>
      <!-- <h3>{{ uploadTxt }}</h3> -->
      <p class="allowed font-sans text-center text-l text-eggplant-100/[0.4]">{{ uploadTxt }}</p>
      <div class="btn_content pt-12">
        <fun-new-button [buttonType]="'primaryDark'" [size]="'l'" title="{{ 'bid-status.upload-file' | translate }}"
        [classExtra]="' !w-full '" iconPosition="right" iconAnimate="top" icon="upload"></fun-new-button>
      </div>
  </div>
  <div *ngIf="!this.fileId && !isUploadingFile && version !== 'card'" (click)="documentId.click()">
    <fun-new-button [buttonType]="'primaryDark'" [size]="'xl'" title="{{ 'bid-status.upload-file' | translate }}"
        [classExtra]="' !w-full '" iconPosition="right" iconAnimate="top" icon="upload"></fun-new-button>
  </div>
  <div class="loader-container" *ngIf="isUploadingFile">
      <ion-spinner *ngIf="isUploadingFile" name="lines"></ion-spinner>
  </div>

  <div *ngIf="this.fileId && !isUploadingFile" class="file-success flex items-center justify-between !px-6">
      <fun-icon id="documentId" [name]="'file'" [style]="'w-28 h-28 stroke-[2px] stroke-eggplant-100/[0.4] cursor-pointer'" (click)="documentId.click()" ></fun-icon>
      <p class="filename font-sans text-center text-l text-eggplant-100/[0.4]"> {{ fileName }} </p>
      <fun-icon [name]="'x-close'" [style]="'w-20 h-20 stroke-[2px] stroke-alert cursor-pointer'" (click)="resetStatusFile(idDocument)"  ></fun-icon>
  </div>
</div>
